import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import logoImage from '../assets/logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setIsMobileMenuOpen(false);
    
    // If not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 130;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 130;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const goToHome = () => {
    navigate('/');
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-[115px]">
          {/* Logo */}
          <div className="flex items-center -ml-2 relative z-10 cursor-pointer" onClick={goToHome}>
            <img src={logoImage} alt="iXus Group Limited" className="h-[115px] w-auto object-contain" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hvac')}
              className="text-gray-700 hover:text-[#8B1818] font-medium transition-colors duration-200"
            >
              HVAC
            </button>
            <button
              onClick={() => scrollToSection('electrical')}
              className="text-gray-700 hover:text-[#8B1818] font-medium transition-colors duration-200"
            >
              Electrical
            </button>
            <button
              onClick={() => scrollToSection('door-automation')}
              className="text-gray-700 hover:text-[#8B1818] font-medium transition-colors duration-200"
            >
              Door Automation
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-[#8B1818] font-medium transition-colors duration-200"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#8B1818] text-white px-6 py-2 rounded-md hover:bg-[#6B1212] transition-colors duration-200 font-medium"
            >
              Contact Us
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-[#8B1818] transition-colors duration-200"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden pb-4 space-y-3">
            <button
              onClick={() => scrollToSection('hvac')}
              className="block w-full text-left text-gray-700 hover:text-[#8B1818] font-medium py-2 transition-colors duration-200"
            >
              HVAC
            </button>
            <button
              onClick={() => scrollToSection('electrical')}
              className="block w-full text-left text-gray-700 hover:text-[#8B1818] font-medium py-2 transition-colors duration-200"
            >
              Electrical
            </button>
            <button
              onClick={() => scrollToSection('door-automation')}
              className="block w-full text-left text-gray-700 hover:text-[#8B1818] font-medium py-2 transition-colors duration-200"
            >
              Door Automation
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-gray-700 hover:text-[#8B1818] font-medium py-2 transition-colors duration-200"
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#8B1818] text-white px-6 py-2 rounded-md hover:bg-[#6B1212] transition-colors duration-200 font-medium w-full text-left"
            >
              Contact Us
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;